import React, { FunctionComponent } from 'react'
import sanitizeHtml from 'sanitize-html'

export const DangerousHtml: FunctionComponent<{ html: string }> = ({ html }) => {
  const sanitizedHtml = sanitizeHtml(html, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['img']),
    allowedSchemesByTag: {
      img: ['data', 'http', 'https'],
    },
    allowedAttributes: {
      img: sanitizeHtml.defaults.allowedAttributes.img.concat(['style']),
      '*': ['style'],
    },
    allowedClasses: {
      div: ['imageContainer'],
    },
    parseStyleAttributes: false,
  })
  return <span dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
}
DangerousHtml.displayName = 'DangerousHtml'
